import { memo, useContext, useState, Dispatch, SetStateAction } from "react";
import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { NoteText } from "./styledText";
import ImageUploadingFromLib from "Components/ImageUploading";
import { useTheme } from "@mui/material/styles";
import UserContext from "userContext";
import { useTranslation } from "react-i18next";

interface IUploadRegion {
  files: any;
  setFiles: any;
  fileOthers: any;
  setFileOthers: any;
  paper: string;
  setPaper: Dispatch<SetStateAction<string>>;
  dataFormImage: any;
  setDataFromImage: any;
  setCarType: Dispatch<SetStateAction<string>>;
  handleClear: () => void;
}

const UploadRegion = ({
  files,
  setFiles,
  fileOthers,
  setFileOthers,
  paper,
  setPaper,
  dataFormImage,
  setDataFromImage,
  setCarType,
  handleClear,
}: IUploadRegion) => {
  const theme = useTheme();
  const { user } = useContext(UserContext);
  const { t } = useTranslation();
  const [isLoadImg, setIsLoadImg] = useState(false);
  const { pathname } = useLocation();

  const resetSelect = () => {
    handleClear();
  };
  const handleChangeRadioButton = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setPaper(event.target.value);
    setFiles([]);
    setFileOthers([]);
    resetSelect();
    setDataFromImage(null);
  };
  return (
    <>
      {user?.ocrEnable && (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              color: theme.palette.mode === "dark" ? "white" : "black",
            }}
          >
            {pathname !== "/result" && (
              <>
                <NoteText>{t("form.title.description")}</NoteText>
                <NoteText>{t("form.title.ocrNote")}</NoteText>
              </>
            )}
          </div>
          <Grid item xs={12}>
            <RadioGroup
              row
              name="row-radio-buttons-group"
              value={paper}
              onChange={handleChangeRadioButton}
            >
              <FormControlLabel
                value="two"
                control={<Radio />}
                label={
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.mode === "dark" ? "white" : "black",
                    }}
                  >
                    Hai mặt
                  </Typography>
                }
              />
              <FormControlLabel
                value="one"
                control={<Radio />}
                label={
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.mode === "dark" ? "white" : "black",
                    }}
                  >
                    Một mặt
                  </Typography>
                }
              />
            </RadioGroup>
          </Grid>
          <Grid
            item
            xs={paper === "one" ? 12 : 5.9}
            sx={{ px: paper === "one" && pathname !== "/result" ? 20 : 0 }}
          >
            <ImageUploadingFromLib
              setDataFromImage={setDataFromImage}
              resetSelect={resetSelect}
              setIsLoadImg={setIsLoadImg}
              isLoadImg={isLoadImg}
              files={files}
              setFiles={setFiles}
              description={
                paper === "one"
                  ? "Chọn ảnh đăng kiểm xe"
                  : "Chọn ảnh đăng kiểm xe mặt trước"
              }
              type={paper}
              layout="landing"
              files2={fileOthers}
              setFiles2={setFileOthers}
              disabled={false}
              setCarType={setCarType}
            />
          </Grid>
          {paper === "two" && (
            <Grid item xs={5.9}>
              <ImageUploadingFromLib
                setDataFromImage={setDataFromImage}
                resetSelect={resetSelect}
                setIsLoadImg={setIsLoadImg}
                isLoadImg={isLoadImg}
                files={fileOthers}
                setFiles={setFileOthers}
                description="Chọn ảnh đăng kiểm xe mặt sau"
                type={paper}
                layout="landing"
                files2={files}
                setFiles2={setFiles}
                disabled={files.length === 0}
                isBack
                setCarType={setCarType}
              />
            </Grid>
          )}
        </>
      )}
    </>
  );
};

export default memo(UploadRegion);
